import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CookieBanner from "./components/CookieBanner";
import { initAnalyticsFromStoredConsent } from "./analytics/consent";

initAnalyticsFromStoredConsent();

const HomePage = lazy(() => import("./pages/HomePage"));
const SolutionsPage = lazy(() => import("./pages/SolutionsPage"));
const ForWhomPage = lazy(() => import("./pages/ForWhomPage"));
const LegalPage = lazy(() => import("./pages/LegalPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const ArticlePage = lazy(() => import("./pages/ArticlePage"));
const ElderlyCarePage = lazy(() => import("./pages/ElderlyCarePage"));
const DevicesPage = lazy(() => import("./pages/DevicesPage"));
const ComparisonPage = lazy(() => import("./pages/ComparisonPage"));
const PrivatePage = lazy(() => import("./pages/PrivatePage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

const RouteFallback = () => (
  <div
    data-testid="route-loading"
    className="min-h-screen flex items-center justify-center bg-white"
  >
    <div className="w-10 h-10 rounded-full border-4 border-gray-200 border-t-[#1a4a4f] animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sprendimai" element={<SolutionsPage />} />
            <Route path="/kam-skirta" element={<ForWhomPage />} />
            <Route path="/teisine-informacija" element={<LegalPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<ArticlePage />} />
            <Route path="/elderly-care" element={<ElderlyCarePage />} />
            <Route path="/irenginiai" element={<DevicesPage />} />
            <Route path="/palyginimas" element={<ComparisonPage />} />
            <Route path="/privatiems-asmenims" element={<PrivatePage />} />
            <Route path="/privatumo-politika" element={<PrivacyPolicyPage />} />
            <Route path="/pardavimo-ir-naudojimo-salygos" element={<TermsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
